var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "overdue-requests-chart" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.sortedOverdue.length === 0
        ? _c("div", { staticClass: "empty-state" }, [
            _vm._v("\n            Sin datos disponibles\n        "),
          ])
        : _c(
            "div",
            { staticClass: "bars-list" },
            _vm._l(_vm.sortedOverdue, function (item) {
              return _c("div", { key: item.nombre, staticClass: "bar-row" }, [
                _c(
                  "div",
                  { staticClass: "bar-label", attrs: { title: item.nombre } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.nombre) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "bar-track" }, [
                  _c("div", {
                    staticClass: "bar-fill",
                    style: {
                      width: _vm.pct(item.vencidas, _vm.maxValue) + "%",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bar-total" }, [
                  _vm._v(_vm._s(item.vencidas)),
                ]),
              ])
            }),
            0
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "chart-header" }, [
      _c("h5", [
        _c("i", { staticClass: "fal fa-exclamation-triangle text-danger" }),
        _vm._v("\n                Solicitudes Vencidas por Tema\n            "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }